import React from "react"
import SEO from "../components/common/SEO"
import ServicePageHero from "../components/services/ServicePageHero.jsx"

const beautyServices = [
  {
    id: 1,
    title: "Beauté des Mains",
    price: "70 DT",
    description:
      "Soin complet des mains comprenant mise en forme des ongles, soin des cuticules et hydratation.",
  },

  {
    id: 2,
    title: "Beauté des Mains Luxe",
    price: "80 DT",
    description:
      "Version premium incluant exfoliation, masque nourrissant et massage relaxant des mains.",
  },

  {
    id: 3,
    title: "Beauté des Pieds",
    price: "70 DT",
    description:
      "Soin complet des pieds pour retrouver douceur, confort et élégance.",
  },

  {
    id: 4,
    title: "Beauté des Pieds Luxe",
    price: "90 DT",
    description:
      "Expérience luxueuse associant soin profond, exfoliation et massage revitalisant.",
  },

  {
    id: 5,
    title: "Pose Vernis + Mini Soin",
    price: "25 DT",
    description:
      "Mise en beauté rapide comprenant un mini soin et l'application d'un vernis au choix.",
  },
]

export default function BeautyServices() {
  return (
    <>
      <SEO
        title="Beauté des Mains & Pieds | Centre SpaLand Saphir Palace & Spa"
        description="Découvrez nos soins de manucure, pédicure et beauté des mains et pieds dans un cadre de luxe à Hammamet."
        keywords="manucure hammamet, pédicure hammamet, beauté des mains, beauté des pieds, spa hammamet"
        url="https://www.yourdomain.com/services/beaute"
      />

      <main>
        {/* Hero */}
        {/*
        <section
          style={{
            padding: "120px 20px",
            textAlign: "center",
            background: "#f9f6f1",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              marginBottom: "20px",
            }}
          >
            Beauté des Mains & Pieds
          </h1>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              color: "#666",
              lineHeight: "1.8",
            }}
          >
            Offrez à vos mains et à vos pieds des soins professionnels
            dans un environnement raffiné dédié au bien-être et à l'élégance.
          </p>
        </section>
*/}
<ServicePageHero
  title="Beauté des Mains & Pieds"
  description="Des soins esthétiques raffinés pour sublimer vos mains et vos pieds dans un cadre de détente absolue."
  image="/images/service-onglerie.jpg"
/>
        {/* Services */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "30px",
            }}
          >
            {beautyServices.map((service) => (
              <div
                key={service.id}
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "30px",
                  boxShadow:
                    "0 10px 30px rgba(0,0,0,0.08)",
                }}
              >
                <h3
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  {service.title}
                </h3>

                <div
                  style={{
                    marginBottom: "15px",
                    fontWeight: "600",
                    color: "#b8955d",
                    fontSize: "1.1rem",
                  }}
                >
                  {service.price}
                </div>

                <p
                  style={{
                    color: "#666",
                    lineHeight: "1.8",
                    marginBottom: "20px",
                  }}
                >
                  {service.description}
                </p>

                <a
                  href="https://wa.me/21697902051"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    background: "#b8955d",
                    color: "#fff",
                    padding: "12px 24px",
                    borderRadius: "50px",
                    textDecoration: "none",
                    fontWeight: "600",
                  }}
                >
                  Réserver via WhatsApp
                </a>
              </div>
            ))}
          </div>
        </section>
      </main>
    </>
  )
}